import { Injectable, ErrorHandler } from '@angular/core';
import { LogService } from './log-service';

@Injectable()
export class ErrorHandlerService extends ErrorHandler {

    constructor(private logService: LogService) {
        super();
    }

    handleError(error: Error) {
        console.error("*** ERROR :" + error.name + " " + error.message);
        this.logService.logException(error); // Manually log exception
    }
}